import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-upload-branch-alias',
  templateUrl: './upload-branch-alias.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UploadBranchAliasComponent {
  upload = input<any>(null);
  branchAliasChange = output<Event>();

  onBranchAliasChange(event: Event) {
    this.branchAliasChange.emit(event);
  }
}
